import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import apis from "../services";
import { FaSearch } from "react-icons/fa";

const ActiveCoin = ({ showHeader = true }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [tokenData, setTokenData] = useState([]);
  const [hasMoreData, setHasMoreData] = useState(true);
  const [loading, setLoading] = useState(false);
  const [selectedRound, setSelectedRound] = useState(""); 
  const [rounds, setRounds] = useState([]);
  const [roundsFetched, setRoundsFetched] = useState(false);

  const navigate = useNavigate();
  const pageSize = 50;

  const handleRoundChange = async (e) => {
    const selectedRound = e.target.value;
    setSelectedRound(selectedRound);
    setCurrentPage(1);
    if (selectedRound === "all") {
      fetchTokenData(1, "", true, "");
    } else {
      fetchTokenData(1, "", true, selectedRound);
    }
  };

  const handleDropdownFocus = async () => {
    if (!roundsFetched) {
      try {
        const response = await apis.activeround();
        if (response.success) {
          setRounds(response.rounds);
          setRoundsFetched(true);
        }
      } catch (err) {
        console.error("Error fetching upcoming rounds data:", err.message);
      }
    }
  };

  const fetchTokenData = async (page, searchedTokenName, isSearched, selectedRound) => {
    setLoading(true);
    try {
      const response = await apis.activeIco({
        page,
        page_size: pageSize,
        tokenName: searchedTokenName,
        isSearched: isSearched,
        round: selectedRound,
      });
      const { tokenDetails } = response;

      if (searchedTokenName || isSearched) {
        setTokenData([]); 
      }

      if (tokenDetails.length > 0) {
        const formattedData = tokenDetails.map((token) => ({
          id: token._id,
          name: token.tokenName,
          round: token.Round,
          totalRaised: token.totalRaised,
          preValuation: token.preValuation,
          category: token.category,
          date: token.Date,
          coinImage: token.image,
        }));
        setTokenData(page === 1 ? formattedData : prevData => [...prevData, ...formattedData]);
      } else {
        setTokenData(tokenDetails);
      }

      setHasMoreData(tokenDetails.length === pageSize);
    } catch (err) {
      console.error("Error fetching token data:", err.message);
      setTokenData([]);
      setHasMoreData(false);
    } finally {
      setLoading(false);
    }
  };

  const handleSearchTokens = (e) => {
    const searchedText = e.target.value;
    fetchTokenData(1, searchedText, true, "");
    setCurrentPage(1);
  };

  useEffect(() => {
    fetchTokenData(currentPage, "", false, selectedRound);
  
  }, [currentPage, selectedRound]);

  const handleShowMore = () => {
    if (hasMoreData && !loading) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const handleCellClick = async (row) => {
    try {
      const data = await apis.getactiveId(row.id);
      navigate(`/PS-detail`, { state: { id: row.id, apiData: data } });
    } catch (error) {
      console.error("Error fetching API data:", error);
    }
  };


  const skeletonStyle = `
    .skeleton {
      background: linear-gradient(
        90deg,
        rgba(240,240,240,0.09) 25%,
        rgba(200,200,200,0.18) 50%,
        rgba(240,240,240,0.09) 75%
      );
      background-size: 200% 100%;
      animation: shimmer 1.2s infinite linear;
      border-radius: 6px;
    }
    @keyframes shimmer {
      0% { background-position: -150% 0; }
      100% { background-position: 150% 0; }
    }
    .skeleton-text { height: 16px; width: 85%; margin: 8px 0; }
    .skeleton-circle { height: 20px; width: 20px; border-radius: 50%; display: inline-block; }
  `;

  return (
    <div className="newpool-back">
      <style>{skeletonStyle}</style>
      <div className="mergeSearchbar">
        <div className="search-bar">
          <form>
            <div className="search-input-wrapper">
              <input
                type="text"
                placeholder="Search by token name"
                onChange={handleSearchTokens}
                className="search-input"
              />
            </div>
          </form>
        </div>
        <div className="upcoming-start-dropdown-container">
          <select
            id="round-select"
            className="upcoming-start-dropdown"
            onChange={handleRoundChange}
            onFocus={handleDropdownFocus}
            value={selectedRound}
          >
            <option value="" disabled>Select a round</option>
            <option value="all">All</option>
            {rounds.map((round, index) => (
              <option key={index} value={round}>{round}</option>
            ))}
          </select>
        </div>
      </div>
      <div className="table-container">
        <table className="table-table-container">
          <thead className="active-header">
            <tr>
              <th>Project Name</th>
              <th>Round</th>
              <th>Total Raised</th>
              <th>Pre-Valuation</th>
              <th>Categories</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              Array.from({ length: 10 }).map((_, idx) => (
                <tr key={idx}>
                  <td>
                    <div style={{ display: "flex", alignItems: "center", gap: 7 }}>
                      <div className="skeleton skeleton-circle"></div>
                      <div className="skeleton skeleton-text" style={{ width: "70%" }}></div>
                    </div>
                  </td>
                  <td><div className="skeleton skeleton-text" /></td>
                  <td><div className="skeleton skeleton-text" /></td>
                  <td><div className="skeleton skeleton-text" /></td>
                  <td><div className="skeleton skeleton-text" /></td>
                  <td><div className="skeleton skeleton-text" /></td>
                </tr>
              ))
            ) : (
              tokenData.map((row, index) => (
                <tr key={index}>
                  <td className="coin-name-cell" style={{ cursor: "pointer" }}>
                    <a
                      href="#"
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={e => { e.preventDefault(); handleCellClick(row); }}
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <img
                          src={row.coinImage}
                          alt={row.name}
                          style={{ width: "20px", marginRight: "5px" }}
                          onError={e => { e.target.src = "/deafult.png"; }}
                        />
                        <span>{row.name}</span>
                      </div>
                    </a>
                  </td>
                  <td>{row.round}</td>
                  <td>{row.totalRaised}</td>
                  <td>{row.preValuation}</td>
                  <td>{row.category}</td>
                  <td>{row.date}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      {hasMoreData && (
        <div className="show-more-container">
          <button onClick={handleShowMore} disabled={loading}>
            {loading ? "Loading..." : "Show More"}
          </button>
        </div>
      )}
    </div>
  );
};

export default ActiveCoin;
